"use client";
import { useRef } from "react";
import type { ContourVariant } from "./contours";
import { useContourField } from "./useContourField";
import { cn } from "./utils";

/**
 * The contour rings, as a decorative canvas. Placement belongs to the caller - the
 * research band, the contact page and the docs landing each crop it differently - so
 * this only draws; pass `className` with the position and size.
 */
export function ContourCanvas({ variant = "band", className }: { variant?: ContourVariant; className?: string }) {
  const ref = useRef<HTMLCanvasElement>(null);
  useContourField(ref, variant);
  return <canvas ref={ref} aria-hidden className={cn("pointer-events-none absolute", className)} />;
}
